import React from "react";
import { Table, Flex } from "antd";
import TimesCard from "./card";
import { getCurrentShop, getCurrentShopId } from "../../shop/get-current-shop";
import SwitchShop from "../../shop/switch-shop";

export default () => { 
    const [cardList, setCardList] = React.useState([]);
    const params = new URLSearchParams(window.location.search);
    const [shopId, setShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
            params.set("shopId", id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getCardList();
        }
    }, [shopId]);

    const getCardList = async () => {
        if (!shopId) return;
        
        const response = await fetch(`/api/promotion/goods-card-list?${params.toString()}`);
        return await response.json();
    }

    return (
        <div>
            <SwitchShop />
            <h2>次卡售卖明细</h2>
            <Flex gap={10} wrap={"wrap"}>
                {
                    cardList?.length && (
                        cardList.map((card, index) => (
                            <TimesCard style={{ minWidth: '300px', width: '100%', maxWidth: '600px' }} key={card.cardId} content={card} />
                        ))
                    )
                }
            </Flex>
            
        </div>
    );
};